import {
  FaWifi,
  FaSwimmingPool,
  FaDumbbell,
  FaSpa,
  FaUtensils,
  FaBeer,
  FaConciergeBell,
  FaSnowflake,
  FaParking,
  FaWheelchair,
  FaPaw,
  FaSmokingBan,
  FaUmbrellaBeach,
  FaClock,
  FaBriefcase,
  FaTshirt,
  FaChair,
  FaLeaf,
  FaMusic,
  FaCalendarCheck,
  FaShoppingBag,
  FaTruck,
  FaWater,
  FaMountain,
  FaTree,
  FaTint,
  FaQuestionCircle,
} from 'react-icons/fa';

// Normalize amenity strings to a common key (lowercase, underscores, strip punctuation)
export const normalizeAmenity = (str) => {
  return String(str || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/\+/g, ' plus ')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_{2,}/g, '_');
};

// Base map of normalized amenity keys to icon components
const baseIconMap = {
  // Hotels common
  free_wifi: FaWifi,
  wifi: FaWifi,
  wi_fi: FaWifi,

  pool: FaSwimmingPool,
  swimming_pool: FaSwimmingPool,

  gym: FaDumbbell,
  fitness_center: FaDumbbell,

  spa: FaSpa,

  restaurant: FaUtensils,
  dining: FaUtensils,

  bar: FaBeer,

  room_service: FaConciergeBell,
  concierge: FaConciergeBell,

  air_conditioning: FaSnowflake,
  ac: FaSnowflake,

  parking: FaParking,

  wheelchair_accessible: FaWheelchair,
  wheelchair: FaWheelchair,

  pet_friendly: FaPaw,
  pets_allowed: FaPaw,

  non_smoking_rooms: FaSmokingBan,
  no_smoking: FaSmokingBan,

  beach: FaUmbrellaBeach,
  beach_access: FaUmbrellaBeach,

  river_front: FaWater,
  riverfront: FaWater,

  mountain: FaMountain,
  mountain_view: FaMountain,

  lake: FaWater,
  lakefront: FaWater,

  forest: FaTree,

  waterfall: FaTint,

  volcano: FaMountain,
  vulcano: FaMountain,

  _24_hour_front_desk: FaClock,
  twenty_four_hour_front_desk: FaClock,

  business_center: FaBriefcase,

  laundry: FaTshirt,

  // Restaurants common
  outdoor_seating: FaChair,
  vegetarian_options: FaLeaf,
  vegan_options: FaLeaf,
  gluten_free_options: FaLeaf,
  family_friendly: FaLeaf,
  live_music: FaMusic,
  reservations: FaCalendarCheck,
  takeout: FaShoppingBag,
  delivery: FaTruck,
  waterfront: FaWater,
};

export const getAmenityIcon = (name) => {
  const key = normalizeAmenity(name);
  return baseIconMap[key] || FaQuestionCircle;
};
